import utils from 'utils';
class roleListCtrl {
  constructor(
    $scope,
    httpRequest,
    $state,
    sweetalert,
    initSortService,
    $uibModal,
    logger
  ) {
    httpRequest.get_dictByTypeArr(['role_type']).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value);
    });

    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        roleName: '',
        createUser: '',
        roleType: '',
      },
    };
    $scope.reset = function reset() {
      $scope.queryParam.param = {
        roleName: '',
        createUser: '',
        roleType: '',
      };
    };
    $scope.queryRoleList = function queryRoleList() {
      $scope.queryParam = sessionStorage.roleListParam
        ? JSON.parse(sessionStorage.roleListParam)
        : $scope.queryParam;
      httpRequest.get_permissionRoleList($scope.queryParam).then((res) => {
        $scope.listData = res.data.value.list;
        utils.loaded();
        $scope.totalItems = res.data.value.total;
        $scope.queryParam.pageNum = res.data.value.pageNum;
      });
    };
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      sessionStorage.setItem(
        'roleListParam',
        JSON.stringify({
          orderMap: $scope.queryParam.orderMap,
          pageNum: $scope.queryParam.pageNum,
          pageSize: $scope.queryParam.pageSize,
          param: sessionStorage.roleListParam
            ? JSON.parse(sessionStorage.roleListParam).param
            : {
                roleName: '',
                createUser: '',
                roleType: '',
              },
        })
      );
      $scope.queryRoleList();
    };
    $scope.queryRoleList();
    // 表头排序
    $scope.orderMap = initSortService('roleListParam');
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem(
        'roleListParam',
        JSON.stringify($scope.queryParam)
      );
      $scope.queryRoleList();
    };
    $scope.search = function () {
      sessionStorage.setItem(
        'roleListParam',
        JSON.stringify($scope.queryParam)
      );
      $scope.queryRoleList();
    };

    $scope.tableDropdownConfig = [
      {
        label: '编辑',
        handler(item) {
          $state.go('system.permission.role.edit', {
            roleId: item.roleId,
            orgId: item.orgId,
          });
        },
        showWhile(item, hasPermit) {
          if (item.roleType == 2) {
            return false;
          }
          if (item.roleType == 1 && $scope.userType != '0') {
            return false;
          }
          return hasPermit('edit_role');
        },
      },
      {
        label: '查看用户',
        handler(item) {
          const search = encodeURI(
            JSON.stringify({
              ownerRoleId: item.roleId,
              orgIdList: [item.orgId],
            })
          );
          //   原有的写法  导致非admin查看用户报错
          // $scope.userType == '0'
          //   ? encodeURI(
          //       JSON.stringify({
          //         ownerRoleId: item.roleId,
          //         orgIdList: [item.orgId],
          //       })
          //     )
          //   : encodeURI(
          //       JSON.stringify({
          //         ownerRoleId: item.roleId,
          //       })
          //     );
          //   return $state.go('system.permission.user.list', {
          //     search: search,
          //   });
          //   优化跳到新页面
          const _url = $state.href(
            'system.permission.user.list',
            {
              search: search,
            },
            { reload: true }
          );
          window.open(_url, '_blank');
        },
        showWhile(item, hasPermit) {
          return hasPermit('view_user');
        },
      },
      {
        label: '添加用户',
        handler(item) {
          $uibModal
            .open({
              templateUrl: 'rolrAddUser.html',
              openedClass: 'mod-modal mod-modal-md modal-role-add-user-page',
              animation: true,
              controller: [
                '$scope',
                'obj',
                '$uibModalInstance',
                'logger',
                'httpRequest',
                function ($scope, obj, $uibModalInstance, logger, httpRequest) {
                  $scope.role = obj.role;
                  $scope.currentOrg = obj.currentOrg;
                  // 获取机构用户
                  $scope.orgUserTree = [];
                  $scope.roleUserIdList = [];

                  function getOrgUser() {
                    httpRequest
                      .get_getOrgUserList($scope.currentOrg.orgId)
                      .then((res) => {
                        $scope.orgUserTree = res.data.value;
                        initOrgUser();
                      });
                  }
                  getOrgUser();

                  function getRoleUser() {
                    httpRequest
                      .get_getRoleUserList({
                        roleId: $scope.role.roleId,
                        orgId: $scope.currentOrg.orgId,
                      })
                      .then((res) => {
                        $scope.roleUserIdList = res.data.value;
                        initOrgUser();
                      });
                  }
                  getRoleUser();

                  function initOrgUser() {
                    if (!$scope.orgUserTree.length) {
                      return;
                    }
                    for (let org of $scope.orgUserTree) {
                      if (!org.userList.length) {
                        org.isCollapsed = false;
                        org.isShow = false;
                        continue;
                      }
                      org.isShow = true;
                      org.isCollapsed = false;
                      for (let user of org.userList) {
                        user.isShow = true;
                        user.isSelected = false;
                        $scope.roleUserIdList.forEach((item) => {
                          if (user.userId === item) {
                            user.isSelected = true;
                          }
                        });
                      }
                    }

                    setOrgSelected();
                  }
                  initOrgUser();

                  function setOrgSelected() {
                    for (let org of $scope.orgUserTree) {
                      org.isSelected = true;
                      for (let user of org.userList) {
                        if (!user.isSelected) {
                          org.isSelected = false;
                        }
                      }
                    }
                  }

                  function filterUser(value) {
                    for (let org of $scope.orgUserTree) {
                      org.isShow = false;
                      if (!org.userList.length) {
                        continue;
                      }
                      for (let user of org.userList) {
                        user.isShow = false;
                        if (user.realName.indexOf(value) > -1) {
                          org.isCollapsed = false;
                          org.isShow = true;
                          user.isShow = true;
                        }
                      }
                    }
                  }
                  $scope.searchValue = '';
                  $scope.searchChange = function searchChange() {
                    filterUser($scope.searchValue);
                  };

                  $scope.onOrgSelect = function onOrgSelect(org) {
                    if (!org.userList.length) {
                      return;
                    }
                    let length = 0;
                    org.userList.forEach((user) => {
                      if (user.isSelected) {
                        length = length + 1;
                      }
                    });
                    if (length === org.userList.length) {
                      org.isSelected = false;
                      org.userList.forEach((user) => {
                        user.isSelected = false;
                      });
                    } else {
                      org.isSelected = true;
                      org.userList.forEach((user) => {
                        // if (user.isShow) {
                        user.isSelected = true;
                        // }
                      });
                    }
                  };
                  $scope.onUserSelect = function onUserSelect(user, org) {
                    let length = 0;
                    org.userList.forEach((user) => {
                      if (user.isSelected) {
                        length = length + 1;
                      }
                    });
                    if (length === org.userList.length) {
                      org.isSelected = true;
                    } else {
                      org.isSelected = false;
                    }
                  };

                  function getSelectedUserIdList() {
                    let userIdList = [];
                    for (let org of $scope.orgUserTree) {
                      if (!org.userList.length) {
                        continue;
                      }
                      for (let user of org.userList) {
                        if (user.isSelected) {
                          userIdList.push(user.userId);
                        }
                      }
                    }
                    return userIdList;
                  }

                  $scope.cancel = function cancel() {
                    $uibModalInstance.dismiss();
                  };

                  $scope.ok = function ok() {
                    let userIdList = getSelectedUserIdList();
                    let obj = {
                      roleId: $scope.role.roleId,
                      orgId: $scope.currentOrg.orgId,
                      userIdList: userIdList,
                    };
                    $uibModalInstance.close(obj);
                  };
                },
              ],
              resolve: {
                obj() {
                  return {
                    role: item,
                    currentOrg: {
                      orgId: item.orgId,
                      orgName: item.orgName,
                    },
                  };
                },
              },
            })
            .result.then(
              (obj) => {
                httpRequest.post_updateRoleUser(obj).then(() => {
                  logger.logSuccess('修改成功');
                  $scope.queryRoleList();
                });
              },
              () => {}
            );
        },
        showWhile(item, hasPermit) {
          return hasPermit('role_add_user');
        },
      },
      {
        label: '删除',
        handler(item) {
          sweetalert.confirm('操作提醒', '确定删除此角色').then(
            () => {
              httpRequest
                .post_permissionRemoveRole(item.roleId, '删除角色成功')
                .then(() => {
                  $scope.queryRoleList();
                });
            },
            () => {}
          );
        },
        showWhile(item, hasPermit) {
          if (item.roleType == 2) {
            return false;
          }
          if (item.roleType == 1 && $scope.userType != '0') {
            return false;
          }
          return hasPermit('del_role');
        },
      },
    ];

    // 查看当前角色下的用户
    $scope.viewUser = function (roleName) {
      roleName = encodeURI(roleName);
      return $state.go('system.permission.user.list', {
        roleName,
      });
    };

    //

    // 机构树组件参数
    $scope.expandedNodes = [];
    $scope.treeOptions = {
      nodeChildren: 'children',
      dirSelectable: true,
      allowDeselect: false,
      injectClasses: {
        ul: 'a1',
        li: 'a2',
        liSelected: 'a7',
        iExpanded: 'a3',
        iCollapsed: 'a4',
        iLeaf: 'a5',
        label: 'a6',
        labelSelected: 'a8',
      },
    };

    $scope.userType = JSON.parse(localStorage.user_info).user.userType;

    $scope.showSelected = function showSelected(org) {
      // 重查机构角色
      $scope.queryParam.param.orgId = org.orgId;
      $scope.queryParam.pageNum = 1;
      sessionStorage.setItem('rolePageOrg', JSON.stringify(org));
      sessionStorage.setItem(
        'roleListParam',
        JSON.stringify($scope.queryParam)
      );
      $scope.queryRoleList();
    };

    $scope.$on('$stateChangeStart', (e, toState) => {
      if (toState.name.indexOf('system.permission.role') == -1) {
        sessionStorage.removeItem('rolePageOrg');
        sessionStorage.removeItem('roleListParam');
      }
    });
  }
}
roleListCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  'sweetalert',
  'initSortService',
  '$uibModal',
  'logger',
];
export default roleListCtrl;



// WEBPACK FOOTER //
// ./src/app/system/permission/role/roleListCtrl.js